import type {ReactElement} from 'react';
import React from 'react';
import {StyleThumbnailOptions} from '@Panels/poster-editor-item-font-style-panel/components/style-thumbnail-options';
import {TextStyleOptions} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-styling-options/base-styling-options.types';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromTextStylesOfSelectedTextSlideItem} from '@Hooks/poster-editor/useGetKeyFromTextStylesOfSelectedTextSlideItem';

export function TextSlideStyleOption(): ReactElement | null {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const activeSlide = activeSlideUID && activeItem?.isSlideshow() ? activeItem.getSelectedSlide() : null;
  const isBold = useGetKeyFromTextStylesOfSelectedTextSlideItem('isBold');
  const isItalic = useGetKeyFromTextStylesOfSelectedTextSlideItem('isItalic');
  const underline = useGetKeyFromTextStylesOfSelectedTextSlideItem('underLine');
  const lineThrough = useGetKeyFromTextStylesOfSelectedTextSlideItem('lineThrough');
  const stroke = useGetKeyFromTextStylesOfSelectedTextSlideItem('stroke');

  if (!activeItem?.isSlideshow()) {
    return null;
  }

  if (!activeSlide?.isTextSlide()) {
    return null;
  }

  if (isBold === undefined || isItalic === undefined || underline === undefined || lineThrough === undefined) {
    return null;
  }

  const applyStyle = (type: TextStyleOptions): void => {
    switch (type) {
      case TextStyleOptions.BOLD: {
        activeSlide.toggleBold();
        return;
      }
      case TextStyleOptions.ITALIC: {
        activeSlide.toggleItalic();
        return;
      }
      case TextStyleOptions.UNDERLINE: {
        activeSlide.toggleUnderline();
        return;
      }
      case TextStyleOptions.STRIKE_THROUGH: {
        activeSlide.toggleLineThrough();
        return;
      }
      default:
        throw new Error('unhandled text styling option');
    }
  };

  const getContent = (): ReactElement => {
    return <StyleThumbnailOptions isBold={isBold} isItalic={isItalic} isUnderline={underline} isLineThrough={lineThrough} applyStyle={applyStyle} isBoldDisabled={stroke} />;
  };

  return getContent();
}
